export default "__VITE_ASSET__5d88c54f__"